'use client';

import List from '@enlighten/design-system/dist/List';
import ListItem from '@enlighten/design-system/dist/ListItem';
import ListItemButton from '@enlighten/design-system/dist/ListItemButton';
import Typography from '@enlighten/design-system/dist/Typography';

import type { ITutorialStepComponent } from '..';
import TutorialLayout from '../TutorialLayout';

export default function Business({ onChangeComponent }: ITutorialStepComponent) {
	return (
		<TutorialLayout visibleAvatar title={'어떤 사업에\n관심이 있으신가요?'} onChangeComponent={onChangeComponent}>
			<List
				disablePadding
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: 2,
				}}
			>
				{[
					{
						title: '발전소를 지어서 수익을 올리고 싶어요.',
						onClick() {
							onChangeComponent('start');
						},
					},
					{
						title: '전기 요금을 아끼고 싶어요.',
						onClick() {
							onChangeComponent('house');
						},
					},
					{
						title: '새로운 태양광 소식을 알고 싶어요.',
						onClick() {
							onChangeComponent('news');
						},
					},
				].map(({ title, onClick }, i) => (
					<ListItem key={i} disablePadding disableGutters>
						<ListItemButton
							onClick={onClick}
							sx={(theme) => ({
								border: `1px solid ${theme.palette.grey['400']}`,
								borderRadius: '4px',
								padding: '20px 24px',
								cursor: 'pointer',
								transition: 'all 0.2s ease',
								':hover': {
									bgcolor: '#F9F6FF',
									borderColor: 'primary.light',
									'.MuiTypography-root': {
										color: 'primary.light',
										fontWeight: 700,
									},
								},
								'.MuiTypography-root': {
									transition: 'all 0.2s ease',
								},
							})}
						>
							<Typography fontSize={16}>{title}</Typography>
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</TutorialLayout>
	);
}
